var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetingSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29116",
    "data-name": "Group 29116",
    transform: "translate(-550 -182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13395",
    "data-name": "Rectangle 13395",
    width: 32,
    height: 32,
    transform: "translate(550 182)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(264.837 -102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M299.62,306.923q.154.047.312.088l.373,2.576h2.986l.373-2.576a7.42,7.42,0,0,0,1.92-.795l2.086,1.558,2.112-2.111-1.558-2.085a7.414,7.414,0,0,0,.8-1.919l2.577-.373V298.3l-2.577-.373a7.415,7.415,0,0,0-.8-1.919l1.558-2.085-2.112-2.111-2.086,1.558a7.421,7.421,0,0,0-1.92-.795L303.292,290h-2.986l-.373,2.576a7.422,7.422,0,0,0-1.92.795l-2.087-1.558-2.111,2.111,1.558,2.085a7.415,7.415,0,0,0-.8,1.919L292,298.3v2.985l2.577.373q.086.332.2.651",
    transform: "translate(-0.435)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M293.924,317.146l6.251-6.251a.42.42,0,0,1,.429-.1,4.134,4.134,0,0,0,5.323-4.73.417.417,0,0,0-.7-.223l-1.893,1.893a.414.414,0,0,1-.585,0l-1.755-1.755a.414.414,0,0,1,0-.585l1.893-1.893a.416.416,0,0,0-.223-.7,4.133,4.133,0,0,0-4.729,5.323.42.42,0,0,1-.1.429l-6.251,6.251a1.442,1.442,0,0,0,0,2.04l.3.3A1.442,1.442,0,0,0,293.924,317.146Z",
    transform: "translate(0 -7.214)",
    fill: "none",
    stroke: "#8a8a8a",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingSettingIcon);
export default __webpack_public_path__ + "static/media/meetingSetting_icon.cff65993.svg";
export { ForwardRef as ReactComponent };